module.exports = __webpack_public_path__ + "facebook-06f944323db70ebfb03e.svg";